<template>
    <form>
        <div class="form-row">
            <div class="col-4">
                <label for="name">Kontoname</label>
                <input
                    v-model="t_name"
                    type="text"
                    class="form-control"
                    id="name"
                    placeholder="Kontoname"
                    title="Eindeutiger Kontoname"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-row">
            <div class="col-4">
                <label for="groupMembership">Gruppe</label>
                <select
                    v-model="t_groupMembership"
                    class="custom-select"
                    title="Mitglieder dieser Gruppe"
                    id="groupMembership">
                    <option value=0 selected>Gruppe auswählen...</option>
                    <option v-for="item_name in user_group_list" :key="item_name" :value="item_name">
                        {{ item_name }}
                    </option>
                    
                </select>
            </div>
        </div>
        <div class="form-row d-flex justify-content-end">
            <div class="p-0">
                <a v-on:click="perform('SAVE')" v-on:submit.prevent="onSubmit" class="btn btn-success" href="#" role="button">
                    Konto speichern
                </a>
            </div>
        </div>
        
    </form>
</template>

<script>
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import {en, de} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'AddFinAccount',
    components: {
        Datepicker
    },
    data() {
        return {
            error_msg: 'No Error',
            t_name: '',
            t_groupMembership: '',
            en: en,
            de: de,
            
        }
    },
    methods: {
        perform(actionType) {
            if (confirm('Konto speichern?')) {
                var msg = {type: "NONE"}

                const data = new FormData();
                data.append('name', this.t_name)
                data.append('groupMembership', this.t_groupMembership)
                data.append('actionType', actionType)
                // eslint-disable-next-line
                console.log( this.t_date);
                var credentials = JSON.parse(localStorage.getItem('credentials'))
                
                axios({
                    url: process.env.VUE_APP_ROOT_API
                        + '/accounts',
                    data: data,
                    auth: credentials,
                    method: 'post'
                })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                })
                .then(resp => {
                    msg = resp.data
                    // eslint-disable-next-line
                    console.log("Message")
                    // eslint-disable-next-line
                    console.log(msg)
                    if (!(msg.type == "NONE")) {
                        // eslint-disable-next-line
                        console.log("Pushing error")
                        this.$store.commit('add_message', msg)
                    } else if (!(msg.type == "ERROR")) {
                        this.t_userName = ''
                        this.t_commonName = ''
                        this.t_groupMembership = ''
                    }
                });
                this.$store.dispatch('loadData')
            }
            
        }
    },
    computed: {
        accountName () {
            return this.$store.state.current_acc
        },
        user_group_list() {
            var group_names = []
            this.$store.state.group_list.groups.forEach(group => {
                group_names.push(group.name)
            });
            return group_names
        }
    }
}
</script>

<style scoped>

</style>

